import { put, select, takeEvery } from 'redux-saga/effects'
import { UPDATE_LOADING, SET_LOADING } from '@redux/actions/types'


const getLoaders = state => state.ui.isLoading

/**
 * Appends a new loader entry to the global loading state array.
 * @param root0
 * @param root0.loadingType
 * @param root0.meta
 */
function * addLoading({ loadingType, meta }) {
  const loaders = yield select(getLoaders)

  yield put({
    type: SET_LOADING,
    payload: [...loaders, { loadingType, meta }]
  })
}

/**
 * Removes a loader entry from the global loading state array by type and meta.
 * @param root0
 * @param root0.loadingType
 * @param root0.meta
 */
function * removeLoading({ loadingType, meta }) {
  const loaders = yield select(getLoaders)
  const newLoaders = loaders.filter(
    loader => loader.loadingType !== loadingType && loader.meta !== meta
  )

  yield put({
    type: SET_LOADING,
    payload: newLoaders
  })
}

/**
 * Routes an UPDATE_LOADING action to either add or remove a loader entry.
 * @param action
 */
function * onUpdateLoading(action) {
  const {
    payload: { loadingAction, loadingType, meta }
  } = action

  switch (loadingAction) {
  case 'set':
    yield addLoading({ loadingType, meta })
    break
  case 'unset':
    yield removeLoading({ loadingType, meta })
    break
  default:
    break
  }
}

/**
 * Automatically manages loading state for actions that carry setLoading or previousAction metadata.
 * @param action
 */
function * checkLoading(action) {
  const setLoading = action.payload?.setLoading

  if (setLoading) {
    yield onUpdateLoading({
      payload: {
        loadingAction: 'set',
        loadingType: action.type,
        meta: setLoading.meta
      }
    })
  }

  if (action.meta?.previousAction) {
    yield onUpdateLoading({
      payload: {
        loadingAction: 'unset',
        loadingType: action.meta?.previousAction?.type,
        meta: action.meta?.previousAction.payload.setLoading?.meta
      }
    })
  }
}


/**
 * Root saga that watches for loading state updates and auto-loading actions.
 */
function * watchUI() {
  yield takeEvery(action => action.meta?.previousAction, checkLoading)
  yield takeEvery(action => action.payload?.setLoading, checkLoading)
  yield takeEvery(UPDATE_LOADING, onUpdateLoading)
}

export default watchUI
